import { version } from 'tesseract.js/package.json'

export const tesseractVersion: string = version
